<span class="gs-dd-trigger-wrap" (click)="toggle($event)" (keydown.enter)="toggle($event)" (keydown.space)="toggle($event)">
  <ng-content select="[gs-dd-trigger]"></ng-content>
</span>
<div class="gs-dd-panel"
     [class.open]="open"
     [class.align-right]="align === 'right'"
     [class.align-left]="align === 'left'"
     [style.width]="width"
     [style.top]="'calc(100% + ' + offsetTop + ')'">
  <ng-content select="[gs-dd-panel]"></ng-content>
</div>
